module.exports = __webpack_public_path__ + "static/media/resources.971f81bc.png";